import { on } from '../helpers/shortcuts';
import S from './shared';

export default () => {
  const dropdowns = document.querySelectorAll('ul.is-style-dropdown > li > ul');

  if (dropdowns.length < 1) {
    return;
  }

  [...dropdowns].forEach(dropdown => {
    const parent = dropdown.parentElement;
    parent.removeChild(dropdown);
    parent.innerHTML = parent.innerHTML.replace(
      /^(.*)$/,
      '<button class="dropdown-trigger o-generic-link" type="button">$1</button>',
    );

    const trigger = parent.querySelector('.dropdown-trigger');
    parent.appendChild(dropdown);

    if (trigger) {
      on('click', trigger, event => {
        event.preventDefault();
        parent.classList.toggle(S.CSS.active);
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/dropdown.js